import { useEffect, useRef } from 'react';

// Replace with your Google AdSense Publisher ID when ready
const ADSENSE_CLIENT_ID = 'ca-pub-XXXXXXXXXXXXXXXX'; // Your AdSense ID here

const AdBanner = ({ 
  slot = '1234567890', // Replace with your ad slot ID
  format = 'auto',
  style = {},
  className = ''
}) => {
  const adRef = useRef(false);

  useEffect(() => {
    if (adRef.current) return;
    adRef.current = true;
    
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, []);

  return (
    <div className={`ad-container ${className}`} style={{ textAlign: 'center', margin: '20px 0', ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={ADSENSE_CLIENT_ID}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      {/* Placeholder shown until AdSense is configured */}
      {ADSENSE_CLIENT_ID.includes('XXXX') && (
        <div 
          className="ad-placeholder bg-muted border-2 border-dashed border-border rounded-lg flex items-center justify-center"
          style={{ minHeight: '90px', padding: '20px' }}
        >
          <span className="text-muted-foreground text-sm">Ad Space - Configure AdSense ID</span>
        </div>
      )}
    </div>
  );
};

// Different ad sizes
export const BannerAd = (props) => (
  <AdBanner format="horizontal" style={{ minHeight: '90px' }} {...props} />
);

export const RectangleAd = (props) => (
  <AdBanner format="rectangle" style={{ minHeight: '250px' }} {...props} />
);

export const InFeedAd = (props) => (
  <AdBanner format="fluid" style={{ minHeight: '100px' }} {...props} />
);

export default AdBanner;
